import { Injectable } from '@angular/core';
import { Agent, AgentList } from '@shared/models/agent';

import agentsMock from '@mocks/getAgents.json';
import agentsForPolicyMock from '@mocks/getAgentsForPolicy.json';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CommonService } from './common.service';
import { PrefferedAgent } from '@shared/models/preffered-agent';

@Injectable({
  providedIn: 'root'
})
export class AgentService {
  private agents: AgentList;
  private agentsForPolicy: AgentList;

  prefferedAgentComponent$ = new BehaviorSubject(false);


  constructor(
      private commonService: CommonService,
      private http: HttpClient) {
    this.agents = agentsMock;
    this.agentsForPolicy = agentsForPolicyMock;
  }

  getAgents(): Observable<AgentList> {
    if (this.commonService.useMocks) {
      return new Observable(observer => observer.next(this.agents));
    }

    return this.http.get<AgentList>(this.commonService.getServiceUrl('agent'));
  }

  getAgentsForPolicy(policyNumber: string): Observable<AgentList> {
    if (this.commonService.useMocks) {
      return new Observable(observer => observer.next(this.agentsForPolicy));
    }

    return this.http.get<AgentList>(this.commonService.getServiceUrl(`agent/${encodeURIComponent(policyNumber)}`));
  }

  setPrefferedAgent(prefferedAgent: PrefferedAgent): Observable<PrefferedAgent> {
    return this.http.post<PrefferedAgent>(this.commonService.getServiceUrl('preffered-agent'), prefferedAgent);
  }

  setPrefferedAgentComponentInit(){
    this.prefferedAgentComponent$.next(true);
  }

  getPrefferedAgentToken(agentNo: string): Observable<Object> {
    return this.http.get<Object>(this.commonService.getServiceUrl('preffered-agent/token/'+agentNo));
  }
}
